// extracted by mini-css-extract-plugin
export default {"section":"style_section__44mHc","sidePadding":"style_sidePadding__vaOwt","secWhite":"style_secWhite__gtsbf"};